import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  theme: 'light',
  sidebarOpen: false,
  modalOpen: false,
  modalType: null,
  modalProps: {},
  toast: {
    open: false,
    message: '',
    type: 'info'
  },
  loading: {
    global: false,
    button: false
  }
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light'
    },
    setTheme: (state, action) => {
      state.theme = action.payload
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload
    },
    openModal: (state, action) => {
      state.modalOpen = true
      state.modalType = action.payload.type
      state.modalProps = action.payload.props || {}
    },
    closeModal: (state) => {
      state.modalOpen = false
      state.modalType = null
      state.modalProps = {}
    },
    showToast: (state, action) => {
      state.toast.open = true
      state.toast.message = action.payload.message
      state.toast.type = action.payload.type || 'info'
    },
    hideToast: (state) => {
      state.toast.open = false
    },
    setGlobalLoading: (state, action) => {
      state.loading.global = action.payload
    },
    setButtonLoading: (state, action) => {
      state.loading.button = action.payload
    }
  }
})

export const {
  toggleTheme,
  setTheme,
  toggleSidebar,
  setSidebarOpen,
  openModal,
  closeModal,
  showToast,
  hideToast,
  setGlobalLoading,
  setButtonLoading
} = uiSlice.actions

export default uiSlice.reducer